import { render } from "./BlogSideBar.vue?vue&type=template&id=6bc344c5"
import script from "./BlogSideBar.vue?vue&type=script&lang=js"
export * from "./BlogSideBar.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/workix-frontend-vue/workix-frontend-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__